/**
 * MRO Scroll Reveal — animación de entrada compartida para todas las
 * secciones "mro-*". Cualquier elemento con el atributo data-mro-reveal
 * queda oculto/desplazado hasta que entra en el viewport, momento en el
 * que se le agrega la clase "is-in-view" (una sola vez).
 *
 * Variantes (valor del atributo): "up" (default), "left", "right", "zoom".
 * Retraso opcional en ms vía data-mro-reveal-delay="120".
 * Respeta prefers-reduced-motion y hace fallback si no hay IntersectionObserver.
 */
(function () {
  var els = document.querySelectorAll('[data-mro-reveal]');
  if (!els.length) return;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll() {
    els.forEach(function (el) {
      el.classList.add('is-in-view');
    });
  }

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    showAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-mro-reveal-delay'), 10) || 0;
        setTimeout(function () {
          el.classList.add('is-in-view');
        }, delay);
        observer.unobserve(el);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -80px 0px' }
  );

  els.forEach(function (el) {
    observer.observe(el);
  });
})();
